exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xlsx-button {\n  border: 0;\n  display: inline-block;\n  border-radius: 30px;\n  padding: 15px;\n  line-height: 0;\n  text-align: center;\n  background-color: #f6f4f5;\n  color: #999998;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n.xlsx-button:hover {\n  color: #4a4a4a;\n}", ""]);

// exports
